import { render, staticRenderFns } from "./duplicate-course-modal.vue?vue&type=template&id=49c83760&scoped=true"
import script from "./duplicate-course-modal.vue?vue&type=script&lang=js"
export * from "./duplicate-course-modal.vue?vue&type=script&lang=js"
import style0 from "./duplicate-course-modal.vue?vue&type=style&index=0&id=49c83760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c83760",
  null
  
)

export default component.exports